import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Grid, InputAdornment, OutlinedInput, Stack, Typography, alpha, styled } from '@mui/material';
// components
// mock
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';

import { debounce } from 'lodash';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import EmtyData from 'src/components/emty-data';
import FillterCabinet from 'src/components/fillter/Fillter';
import Iconify from 'src/components/iconify';
import Loader from 'src/components/loader/loader';
import CellModal from 'src/components/modal/CellModal';
import ChooseCabinetModal from 'src/components/modal/ChooseCabinetModal';
import ExportDeviceModal from 'src/components/modal/ExportDeviceModal';
import QRCodeDeviceModal from 'src/components/modal/QRCodeDeviceModal';
import { CellList } from 'src/sections/@dashboard/cell';
import RadioFilter from './radioFilter';

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
    width: { sm: '100%', lg: '50%' },
    transition: theme.transitions.create(['box-shadow', 'width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter,
    }),
    '&.Mui-focused': {
        // width: 320,
        boxShadow: theme.customShadows.z8,
    },
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
    },
}));
// ----------------------------------------------------------------------

export default function ImportWarehouse() {
    const [visible, setVisible] = useState(false);
    const [visibleExport, setVisibleExport] = useState(false);
    const { t } = useTranslation();
    const params = useParams();
    const isEdit = useRef(false);
    const [data, setData] = useState({});

    const chekcRef = useRef(false);
    const visibleRef = useRef('');
    const dataActionRef = useRef(null);

    const [getFlags, setGetFlags] = useState(false);
    const flagRef = useRef(false);
    const getCabinetFlags = useRef();
    const [tableData, setTableData] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const getDeviceFlags = useRef();
    const [dataCabinet, setDataCabinet] = useState([]);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [valueCabinet, setValueCabinet] = useState(null);
    const [valueDrawer, setValueDrawer] = useState(null);

    const [isChecked, setIsChecked] = useState(false);

    const typeCabinet = useRef();
    const [screenPermissions, setScreenPermissions] = useState({});
    const cabinetRef = useRef();

    const [search, setSearch] = useState('');
    const getRef = useRef(false);
    const [getFlagsSearch, setGetFlagsSearch] = useState(false);
    const [dataSearch, setDataSearch] = useState({});
    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getDataSearch(searchValueDeboun.current), 1000));
    const [visibleQR, setVisibleQR] = useState(false);
    const [visibleCabinet, setVisibleCabinet] = useState(false);
    const [filterType, setFilterType] = useState('all');

    const path = window.location.pathname;

    useEffect(() => {
        setTimeout(() => {
            // getDataCabinet();
            checkStaticticalChecking();
        }, 1000);
        return () => {
            sessionStorage.removeItem('dataCabinet');
        };
    }, []);

    const handleChangeCabinet = (cabinet) => {
        setValueCabinet(cabinet);
        getDataDrawer(cabinet?.id || 0);
    };

    useEffect(() => {
        const chooseCabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
        const chooseCabinetSession = sessionStorage.getItem('cabinet');
        try {
            if (chooseCabinetLocal || JSON.parse(chooseCabinetSession)) {
                if (chooseCabinetLocal) {
                    cabinetRef.current = chooseCabinetLocal;
                    // console.log('cabinetLocal', chooseCabinetLocal)
                    getDataDrawer(chooseCabinetLocal.id);
                } else {
                    const ssCabinet = JSON.parse(chooseCabinetSession);
                    cabinetRef.current = ssCabinet;
                    // console.log('cabinetSession', ssCabinet)
                    getDataDrawer(ssCabinet.id);
                }
                setValueCabinet(cabinetRef.current);
            } else {
                setVisibleCabinet(true);
            }
        } catch (error) {}
    }, []);

    useEffect(() => {
        if (valueCabinet?.id && valueDrawer?.id) {
            getData(valueCabinet.id, valueDrawer.id);
        }
    }, [valueDrawer?.id]);

    useEffect(() => {
        if (visibleExport || visible) {
            window.addEventListener('beforeunload', handleBeforeUnload);
            window.addEventListener('unload', handleBeforeUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleBeforeUnload);
        };
    }, []);

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    };

    // check kiem ke
    const checkStaticticalChecking = useCallback(() => {
        if (chekcRef.current) {
            return;
        }
        chekcRef.current = true;
        const InVal = [1];
        sendRequest(
            serviceList.checkStatisticChecking,
            InVal,
            checkStaticticalCheckingResult,
            true,
            timeOutFunctcheckStaticticalChecking,
            40000
        );
    }, []);

    const checkStaticticalCheckingResult = (reqInfoMap, message) => {
        chekcRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setIsChecked(message.proc_data.rows[0].o_1[0].check_inv_status === '0' ? true : false);
        }
    };

    const timeOutFunctcheckStaticticalChecking = (reqInfo) => {
        chekcRef.current = false;
    };

    const getData = useCallback((idCabinet, idDrawer) => {
        if (flagRef.current) {
            return;
        }
        flagRef.current = true;
        setGetFlags(true);
        if (!idCabinet || !idDrawer) return;
        const InVal = [+params.idPermission, idCabinet, idDrawer];
        sendRequest(serviceList.getAllbox, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            glb_sv.commonEvent.next({ type: eventList.ADD_NOTIFY, data: true });
            // console.log('message => ', message);
            const dataCell = message.proc_data.rows[0].o_1;
            // console.log('datacell => ', dataCell);
            if (dataCell.at(-1)?.cell_lc?.row && dataCell.at(-1)?.cell_lc?.column) {
                let a = 0;
                const arr = [];
                for (let i = 0; i < dataCell.at(-1).cell_lc.row; i++) {
                    arr.push([]);
                    for (let j = 0; j < dataCell.at(-1).cell_lc.column; j++) {
                        arr[i].push(dataCell[a++]);
                    }
                }
                setTableData(arr);
            }
            typeCabinet.current = dataCell[0].cabinet_type;
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setGetFlags(false);
    };

    const getDataCabinet = useCallback(() => {
        if (getCabinetFlags.current) return;
        getCabinetFlags.current = true;
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        getCabinetFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            console.log('dataCabinet', dataRes);
            const dataCabinet = dataRes.filter((item) => item.block_status === '1');
            const session = sessionStorage.getItem('dataCabinet');
            if (session) {
                try {
                    const sessionJson = JSON.parse(session);
                    if (sessionJson?.cabinet?.id && sessionJson?.drawer?.id) {
                        handleChangeCabinet(sessionJson.cabinet);
                    }
                } catch (error) {}
            } else {
                handleChangeCabinet(dataCabinet.length > 0 ? dataCabinet[0] : null);
            }
            setDataCabinet(dataCabinet);
            setDataDrawer([]);
        }
    };

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [valueCabinet?.id]
    );

    const getDataDrawerResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getDeviceFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('data drawer', message);

            const session = sessionStorage.getItem('dataCabinet');
            if (session) {
                try {
                    const sessionJson = JSON.parse(session);
                    if (sessionJson?.cabinet?.id && sessionJson?.drawer?.id) {
                        setValueDrawer(sessionJson.drawer);
                    }
                } catch (error) {}
            } else {
                setValueDrawer(message.proc_data.rows[0].o_1[0]);
            }
            const dataDrawer = message.proc_data.rows[0].o_1;
            if (dataDrawer?.length === 0) {
                // console.log('data drawer', dataDrawer);
                setDataDrawer([]);
                setValueDrawer(null);
                setTableData([]);
                return;
            }
            setDataDrawer(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctCabinet = (reqInfo) => {
        getCabinetFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const getDataSearch = (value = searchValueDeboun.current) => {
        if (getRef.current || !searchValueDeboun.current) {
            return;
        }
        getRef.current = true;
        const InVal = [searchValueDeboun.current.trim(), ''];
        sendRequest(serviceList.getByDeviceCode, InVal, getDataResultSearch, true, timeOutFunctSearch, 40000);
    };

    const getDataResultSearch = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlagsSearch(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            // setSearch('');
            return;
        } else {
            // console.log('Search', message.proc_data.rows[0]);
            if (message.proc_data.rows[0].o_1.length !== 0 && message.proc_data.rows[0].o_2) {
                setVisibleQR(true);
                setDataSearch(message.proc_data.rows[0]);
            }
        }
    };

    const timeOutFunctSearch = (reqInfo) => {
        getRef.current = false;
        setGetFlagsSearch(false);
        // setSearch('');
    };

    useEffect(() => {
        // setSearch('');
    }, [visibleQR]);

    const searchValue = (e) => {
        // console.log('value', e.target.value);
        searchValueDeboun.current = e.target.value;
        setSearch(searchValueDeboun.current);
        throttled.current();
    };

    useEffect(() => {
        if (!tableData || tableData.length === 0) return;

        // Flatten all cells
        const allCells = tableData.flat();

        // Lọc theo filterType
        const filtered = allCells.filter((cell) => {
            switch (filterType) {
                case 'empty':
                    return !cell.device_id;
                case 'empty_zero':
                    return !cell.device_id || cell.qty === 0;
                case 'has_device':
                    return cell.device_id;
                case 'has_device_gt_zero':
                    return cell.device_id && cell.qty > 0;
                case 'all':
                default:
                    return true;
            }
        });

        // Chia lại theo hàng 5 ô
        const newTable = [];
        for (let i = 0; i < filtered.length; i += 5) {
            newTable.push(filtered.slice(i, i + 5));
        }

        setTableFilter(newTable);
    }, [filterType, tableData]);
    return (
        <>
            <Helmet>
                <title> {t('nhap_xuat_tb')} </title>
            </Helmet>

            <Container>
                <ChooseCabinetModal visible={visibleCabinet} setVisible={setVisibleCabinet} />
                <Typography variant="h4" sx={{ mb: 2 }}>
                    {t('nhap_xuat_tb')}
                </Typography>
                {/* <Loader loading={getFlags} /> */}
                <Breadcrumb
                    paths={[
                        {
                            label: t('group_devices'),
                            url: `/home/group/${path?.split('/')[3]}/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('nhap_xuat_tb'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <CellModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    setVisible={setVisible}
                    importWarehouse
                    dataUpdate={data}
                    idCabinet={valueCabinet?.id}
                    idDrawer={valueDrawer?.id}
                    fuctGet={getData}
                    typeCabinet={typeCabinet.current}
                />
                <ExportDeviceModal
                    idPermission={params.idPermission}
                    dataUpdate={data}
                    idCabinet={valueCabinet?.id}
                    idDrawer={valueDrawer?.id}
                    fuctGet={getData}
                    visible={visibleExport}
                    setVisible={setVisibleExport}
                    typeCabinet={typeCabinet.current}
                />
                <QRCodeDeviceModal
                    visible={visibleQR}
                    setVisible={setVisibleQR}
                    dataSearch={dataSearch}
                    setDataSearch={setDataSearch}
                    isImportWarehouse
                />

                {/* <FillterCabinet /> */}
                <Grid container spacing={3} alignItems={'center'} mb={2}>
                    <Grid item xs={12} sm={12} md={6} xl={7}>
                        <StyledSearch
                            value={search}
                            onChange={searchValue}
                            fullWidth
                            placeholder={t('search')}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Iconify
                                        icon="eva:search-fill"
                                        sx={{ color: 'text.disabled', width: 20, height: 20 }}
                                    />
                                </InputAdornment>
                            }
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={5}>
                        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mb: 1 }}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                width={'100%'}
                                justifyContent="flex-end"
                                flexWrap={'wrap'}
                                gap={1}
                                sx={{ mb: 1 }}
                            >
                                {/* {glb_sv.userInfo.group_user !== '3' && (
                                    <FillterCabinet
                                        setValueSort={(data) => {
                                            handleChangeCabinet(data);
                                        }}
                                        arrSort={dataCabinet}
                                        valueSort={valueCabinet ? valueCabinet : null}
                                        labelDisplay="cabinet_nm"
                                        defaultValue={dataCabinet.length > 0 ? dataCabinet[0].cabinet_nm : ''}
                                        title={t('cabinet')}
                                    />
                                )} */}
                                {cabinetRef.current ? (
                                    <>
                                        <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                                            {t('cabinet')}:{' '}
                                        </Typography>
                                        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            {`${cabinetRef.current.cabinet_nm} - ${cabinetRef.current.cabinet_cd}`}
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                                            {t('cabinet')}:{' '}
                                        </Typography>
                                        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            {t('no_cabinet')}
                                        </Typography>
                                    </>
                                )}
                                <FillterCabinet
                                    setValueSort={setValueDrawer}
                                    labelDisplay="drawer_nm"
                                    arrSort={dataDrawer}
                                    valueSort={valueDrawer ? valueDrawer : null}
                                    defaultValue={dataDrawer.length > 0 ? dataDrawer[0].drawer_nm : ''}
                                    title={t('drawer')}
                                />
                                <RadioFilter setFilterType={setFilterType} filterType={filterType} />
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
                {tableFilter.length > 0 ? (
                    <CellList
                        products={tableFilter}
                        setData={setData}
                        dataActionRef={dataActionRef.current}
                        importWarehouse
                        idPermission={params.idPermission}
                        functEdit={(data) => {
                            if (isChecked)
                                return toast.error(t('system_statistical') + ', ' + t('not_action_transaction'));
                            isEdit.current = true;
                            visibleRef.current = 'import';
                            setVisible(true);
                        }}
                        functDelete={(data) => {
                            if (isChecked)
                                return toast.error(t('system_statistical') + ', ' + t('not_action_transaction'));
                            visibleRef.current = 'export';
                            setVisibleExport(true);
                        }}
                        getData={getData}
                        typeCabinet={typeCabinet.current}
                        screenPermissions={screenPermissions}
                    />
                ) : (
                    <EmtyData />
                )}
            </Container>
        </>
    );
}
